/* eslint-disable no-template-curly-in-string */
export const cn = {
    title: {
        manageSubscription: '管理订阅',
        pickYourPlan: '选择计划',
        basicUser: '定价方案',
        overlimitFreemium: '已达到免费版使用上限',
        upgrade: '解锁更多能力',
        overlimit: '已达到当前套餐上限',
        proUser: '管理订阅',
    },
    subtitle: {
        pickYourPlan: '选择适合您的计划',
        basicUser: '按需选择，找到最适合你的方案',
        overlimitFreemium: '当前免费额度已用完，升级后可继续使用。',
        upgrade: '升级套餐，获得更高额度和更多高级功能。',
        overlimit: '需要更多用量？联系销售以获取最适合您的方案。',
        proUser: '管理您的订阅',
    },
    recommend: '推荐',
    currentPlan: '当前方案',
    active: '已激活',
    canceled: '已取消',
    changePlan: '切换方案',
    cancelPlan: '取消方案',
    resumePlan: '恢复方案',
    month: '月',
    year: '年',
    flashSale: '闪促 50% OFF',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '省 ${amount}',
        recommended: '人气首选',
    },
    plans: {
        basic: {
            sectionTitle: '您的基础方案',
            featureTitle: '基础方案功能:',
            name: '基础版',
            price: '免费',
            description: '适合个人初次体验，快速了解技术趋势与解答基础问题',
            features: {
                track: '关注少量技术话题动态',
                'ai-qa': '基础 AI 技术问答',
                triz: '体验 TRIZ 创新方案生成',
                report: '体验技术调研报告生成',
            },
        },
        pro: {
            sectionTitle: '您的方案',
            featureTitle: '专业方案功能',
            name: '个人专业版',
            description: '适合资深研发人员，解锁深度分析能力与专业报告导出',
            buttonText: '立即升级',
            featuresHeader: '方案功能:',
            features: {
                proPlanFeatures: '包含免费版所有功能，额外：',
                track: '监控更多技术话题动态',
                'ai-qa': '更充裕的 AI 问答额度',
                triz: '深度应用 TRIZ 攻克技术难题',
                'triz-library': '解锁完整 TRIZ 创新案例库',
                report: '生成深度专业的技术调研报告',
                download: '支持下载/导出报告文档',
            },
        },
        enterprise: {
            name: '企业版',
            price: '联系我们',
            description: '适合研发团队，提供全流程提效工具与企业级安全管控',
            buttonText: '咨询专家',
            featuresHeader: '包含专业版,以及:',
            features: {
                'in-pro-plus': '包含专业版所有功能，额外：',
                'high-frequency': '满足团队规模化的高频使用需求',
                'triz-expert': 'TRIZ 专家模式（支持自定义参数）',
                'full-cycle': '全流程研发提效',
                'company-search': '公司搜索',
                'competitive-landscape': '竞争格局',
                'assess-technical': '评估技术方案可行性',
                'prevent-design-failure': '预防设计失效风险 (DFMEA)',
                'novelty-search': '检查技术创意新颖性 (查新)',
                'patent-disclosure': '辅助撰写专利交底书',
                'security-control': '安全与管理',
                'internal-distribution': '团队内部分发情报简报',
                'strict-file-upload': '严格的文件上传权限控制',
                'private-incognito': '保护隐私的无痕模式',
                'unified-permission': '统一管理团队成员权限',
                'dedicated-support': '专属客户服务支持',
            },
        },
        api: {
            name: 'API',
            price: '定制化',
            description: '将我们的 AI 模型和专有数据无缝集成到您的工作流中',
            buttonText: '了解更多',
            featuresHeader: '包含专业版,以及:',
            features: {
                'unified-ai-data-loop': '统一的 AI 数据闭环，提供可落地的洞察',
                'modular-components': '通过模块化组件和 SDK 实现即时集成',
                'transparent-usage': '透明的使用模式，确保扩展的可预测性',
                'enterprise-infrastructure': '拥有 99.9% SLA 的企业级基础设施',
                'common-connectivity': '支持主流技术栈的通用连接性',
                'proactive-support': '主动式支持与全栈健康监测',
            },
        },
    },
    viewMoreDetails: '查看更多详情',
    tabs: {
        engineering: '工程研发',
        ip: '知识产权',
        materials: '材料科学',
        lifeSciences: '生命科学',
        comingSoon: '即将上线',
    },
    mse: {
        mostPopular: '最受欢迎',
        savings: '省10%',
        yearlyPrice: '$2,160',
        plans: {
            basic: {
                name: '基础版',
                price: '免费',
                description: '适合验证材料假设或试用平台的科学家',
                cta: '当前方案',
                fi1: '追踪有限技术话题',
                fi2: '材料技术问答',
                fi3: '配方智能体',
            },
            pro: {
                name: '专业版',
                price: '$200',
                period: '/月',
                description: '为在职材料科学家提供完整研究能力',
                cta: '订阅专业版',
                badge: { monthly: '月付', yearly: '年付' },
                fh1: '包含免费版所有功能，额外：',
                fi1: '追踪更多技术话题',
                fi2: '更高使用限额',
                fi3: '解锁来自参考来源的详细配方洞察',
                fi4: '导出配方结果和全文专利',
            },
            enterprise: {
                name: '企业版',
                price: '联系销售',
                description: '在整个团队中扩展材料发现能力',
                cta: '预约演示',
                fh1: '包含专业版所有功能，额外：',
                fi1: '满足团队高频使用需求',
                fi2: '在共享空间协作',
                fh2: '端到端材料智能',
                fi3: 'AI 技术解决方案发现',
                fi4: '早期设计风险分析 (DFMEA)',
                fi5: '全面新颖性评估',
                fi6: 'AI 辅助知识产权文档',
                fh3: '安全与管控',
                fi7: '严格的文件上传控制',
                fi8: '隐私无痕模式',
                fi9: '统一团队权限管理',
                fi10: '专属客户支持',
            },
            api: {
                name: 'API',
                price: '定制化',
                description: '将材料智能体嵌入您现有的基础设施',
                cta: '了解更多',
                fi1: '即插即用部署，灵活按用量计费',
                fi2: '通过 API、组件和连接器直接嵌入现有工作流',
                fi3: '通过 Agent Skills 和 MCP 增强智能体性能',
                fi4: '以企业级安全为核心构建',
            },
        },
    },
    ip: {
        mostPopular: '人气首选',
        plans: {
            basic: {
                name: '基础版',
                price: '免费',
                description: '适合个人初次体验知识产权检索与分析',
                cta: '当前方案',
                fi1: '有限专利检索',
                fi2: '基础专利分析',
                fi3: '体验 AI 专利问答',
            },
            pro: {
                name: '专业版',
                draftingTitle: '专利撰写',
                draftingPrice: '$329',
                draftingDescription: '适合专利代理人，AI 辅助专利撰写与交底书生成',
                draftingCta: '订阅专业版',
                searchTitle: '专利检索',
                searchPrice: '$329',
                searchDescription: '适合研发人员，深度专利检索与技术分析',
                searchCta: '订阅专业版',
                pricePeriod: '/月',
                featuresHeader: '专利检索智能体，含 10 个灵活搜索积分：',
                search_fi1: '新颖性检索（每个任务 1 积分）',
                search_fi2: 'FTO 检索（每个任务 2 积分）',
                search_fi3: '外观设计 FTO 检索（每个任务 1 积分）',
                draftingFeaturesHeader: '多项撰写功能，助力全球专利申请：',
                drafting_fi1: '更多 Hiro 消息额度',
                drafting_fi2: '完整文档导出',
                drafting_fi3: '专利交底书（10 份）',
                drafting_fi4: '专利申请文件（5 份）',
                drafting_fi5: '审查意见答复（5 份）',
                drafting_fi6: '模板 / 指令 / 风格',
                drafting_fi7: 'Word 插件（即将推出）',
            },
            enterprise: {
                name: '企业版',
                price: '联系我们',
                description: '适合知识产权团队，提供全流程 IP 管理与企业级安全管控',
                cta: '预约演示',
                fh1: '包含专业版所有功能，额外：',
                fi1: '满足团队高频使用需求',
                fi2: '团队协作与权限管理',
                fi3: '专利组合分析',
                fi4: '竞争对手专利监控',
                fi5: '专利价值评估',
                fh2: '安全与管控',
                fi6: '严格的文件上传权限控制',
                fi7: '保护隐私的无痕模式',
                fi8: '统一管理团队成员权限',
                fi9: '专属客户服务支持',
            },
            api: {
                name: 'API',
                price: '定制化',
                description: '将专利智能体嵌入您现有的基础设施',
                cta: '了解更多',
                fi1: '即插即用部署，灵活按用量计费',
                fi2: '通过 API、组件和连接器直接嵌入现有工作流',
                fi3: '通过 Agent Skills 和 MCP 增强智能体性能',
                fi4: '以企业级安全为核心构建',
            },
        },
    },
    ls: {
        mostPopular: '人气首选',
        savings: '省$480',
        yearlyPrice: '$4320',
        plans: {
            basic: {
                name: '基础版',
                price: '免费',
                description: '适合验证研究假设或体验平台的个人用户',
                cta: '当前方案',
                fi1: '生命科学领域专属 Hiro 科研问答',
                fi2: '文档精读专利、文献、会议海报对比分析（每次至多上传2个文件）',
                fi3: '体验 Lead化合物分析及 SAR 数据提取（仅限5次）',
                fi4: '2份AI驱动情报简报，提前捕捉市场信号',
            },
            pro: {
                name: '专业版',
                price: '$400',
                period: '/月',
                description: '为科研工作者提供完整的研究能力',
                cta: '订阅专业版',
                badge: { monthly: '月付', yearly: '年付' },
                fh1: '包含基础版全部功能，以及：',
                fi1: '每日使用额度最高提升7.5倍',
                fi3: '文档精读功能扩展（每次至多上传5个文件）',
                fi4: 'Lead化合物分析开放导出（每月5次）',
                fi5: '5份AI驱动情报简报（每周更新）',
            },
            enterprise: {
                name: '企业版',
                price: '联系我们',
                description: '赋能全团队的科研发现',
                cta: '预约演示',
                fh1: '深度科研',
                fi1: 'SAR提取即将上线',
                fi2: '结构到马库什智能体的关联通路',
                fh2: '能力扩展',
                fi3: '更高用量配额与更高性能模型',
                fi4: '内置科研记录系统',
                fi5: '全格式文件导出（FASTA、SDF、SMILES）',
                fi6: '额外专家智能体（知产报告、抗体抗原筛选、马库什撰写）',
                fh3: '安全与管控',
                fi7: '共享项目',
                fi8: '团队协作',
                fi9: '企业级安全与SSO及管理员控制',
                fi10: '专属客户支持',
            },
            api: {
                name: 'API',
                price: '定制化报价',
                description: '让智能体融入您的研究工作流',
                cta: '了解更多',
                fi1: '即插即用部署，按用量灵活计费',
                fi2: '通过API、组件和连接器直接嵌入现有工作流',
                fi3: '借助 Agent Skills 与 MCP 大幅提升智能体能力',
                fi4: '从底层构建企业级安全架构',
            },
        },
    },
    error: {
        createPaymentSessionFailed: '创建支付失败,请稍后重试',
    },
};

export const en = {
    title: {
        manageSubscription: 'Manage Subscription',
        pickYourPlan: 'Pick your plan',
        basicUser: 'plans & pricing',
        overlimitFreemium: 'You\'ve reached your Free plan limit',
        upgrade: 'Unlock more with a paid plan',
        overlimit: 'You\'ve reached your current plan limit',
        proUser: 'Manage Subscription',
    },
    subtitle: {
        pickYourPlan: 'Choose the plan that works for you',
        basicUser: 'Autonomy for all. Choose the best plan for you.',
        overlimitFreemium: 'Your free allowance is used up. Upgrade to continue.',
        upgrade: 'Upgrade for higher limits and more advanced features.',
        overlimit: 'Need more usage? Contact Sales to find a plan that fits your needs.',
        proUser: 'Manage your subscription',
    },
    recommend: 'Recommend',
    currentPlan: 'Current Plan',
    active: 'ACTIVE',
    canceled: 'Canceled',
    changePlan: 'Change plan',
    cancelPlan: 'Cancel plan',
    resumePlan: 'Resume plan',
    month: 'month',
    year: 'year',
    flashSale: 'Flash Sale 50% OFF',
    billingCycle: {
        monthly: 'Monthly',
        yearly: 'Yearly',
        saveAmount: 'Save ${amount}',
        recommended: 'Most Popular',
    },
    plans: {
        basic: {
            sectionTitle: 'Your Basic Plan',
            featureTitle: 'Basic Plan Features:',
            name: 'Basic',
            price: 'Free',
            description: 'Ideal for individuals to explore tech trends and answer basic questions',
            features: {
                track: 'Track limited technical topics',
                'ai-qa': 'Basic Al technical Q&A',
                triz: 'TRIZ innovation generation',
                report: 'Try technical research reports',
            },
        },
        pro: {
            sectionTitle: 'Your Plan',
            featureTitle: 'Pro Plan Futures',
            name: 'Pro',
            description: 'For senior R&D professionals requiring deep analysis and expert reporting',
            buttonText: 'Subscribe to Pro',
            features: {
                proPlanFeatures: 'Everything in Free, plus:',
                track: 'Track more technical topics',
                'ai-qa': 'Expanded AI Q&A allowance',
                triz: 'Deep TRIZ application for complex problems',
                'triz-library': 'Unlock full TRIZ case library',
                report: 'Generate deep professional research reports',
                download: 'Download/Export report documents',
            },
        },
        enterprise: {
            name: 'Enterprise',
            price: 'Contact us',
            description: 'For R&D teams needing full-cycle efficiency tools and enterprise-grade control',
            buttonText: 'Book a Demo',
            features: {
                'in-pro-plus': 'Everything in pro, plus',
                'high-frequency': 'High-frequency usage for teams',
                'triz-expert': 'TRIZ Expert Mode (Custom parameters)',
                'full-cycle': 'Full-cycle R&D Efficiency',
                'company-search': 'Company Search',
                'competitive-landscape': 'Competitive Landscape',
                'assess-technical': 'Assess technical feasibility',
                'prevent-design-failure': 'Prevent design failure risks (DFMEA)',
                'novelty-search': 'Novelty search & validation',
                'patent-disclosure': 'Patent disclosure drafting assistant',
                'security-control': 'Security & Control',
                'internal-distribution': 'Internal intelligence sharing',
                'strict-file-upload': 'Strict fle upload control',
                'private-incognito': 'Private incognito mode',
                'unified-permission': 'Unified team permission management',
                'dedicated-support': 'Dedicated customer support',
            },
        },
        api: {
            name: 'API',
            price: 'Custom',
            description: 'Seamlessly integrate our AI models and proprietary evidence into your workflows',
            buttonText: 'Learn more',
            features: {
                'unified-ai-data-loop': 'Unified AI-data loop for actionable insights',
                'modular-components': 'Instant integration via modular widgets and SDKs',
                'transparent-usage': 'Predictable scaling with transparent usage models',
                'enterprise-infrastructure': 'Enterprise-grade infrastructure with 99.9% SLA',
                'common-connectivity': 'Universal connectivity across leading tech stacks',
                'proactive-support': 'Proactive support and full-stack health monitoring',
            },
        },
    },
    viewMoreDetails: 'View more details',
    tabs: {
        engineering: 'Engineering',
        ip: 'IP',
        materials: 'Materials',
        lifeSciences: 'Life Sciences',
        comingSoon: 'Coming soon',
    },
    mse: {
        mostPopular: 'MOST POPULAR',
        savings: 'Save 10%',
        yearlyPrice: '$2,160',
        plans: {
            basic: {
                name: 'Basic',
                price: 'Free',
                description: 'Ideal for scientists validating a materials hypothesis or testing the platform',
                cta: 'Current Plan',
                fi1: 'Track limited technical topics',
                fi2: 'Materials Technical Q&A',
                fi3: 'Formulation Agent',
            },
            pro: {
                name: 'Pro',
                price: '$200',
                period: '/month',
                description: 'Full research capabilities for working materials scientists',
                cta: 'Subscribe to Pro',
                badge: { monthly: 'Monthly', yearly: 'Yearly' },
                fh1: 'Everything in Free, plus:',
                fi1: 'Track more technical topics',
                fi2: 'Higher usage limits',
                fi3: 'Unlock detailed formulation insights from referenced sources',
                fi4: 'Export formulation results and full-text patents',
            },
            enterprise: {
                name: 'Enterprise',
                price: 'Contact Sales',
                description: 'Scale materials discovery across your entire team',
                cta: 'Book a Demo',
                fh1: 'Everything in Pro, plus:',
                fi1: 'High-frequency usage for teams',
                fi2: 'Collaborate in shared spaces',
                fh2: 'End-to-End Materials Intelligence',
                fi3: 'AI Technical solution discovery',
                fi4: 'Early-stage design risk analysis (DFMEA)',
                fi5: 'Comprehensive novelty assessment',
                fi6: 'AI-assisted IP documentation',
                fh3: 'Security & Control',
                fi7: 'Strict file upload control',
                fi8: 'Private incognito mode',
                fi9: 'Unified team permission management',
                fi10: 'Dedicated customer support',
            },
            api: {
                name: 'API',
                price: 'Custom',
                description: 'Embed materials agents into your existing infrastructure',
                cta: 'Learn More',
                fi1: 'Plug-and-play deployment with flexible, usage-based pricing',
                fi2: 'Embed directly into your existing workflows through APIs, widgets, and connectors',
                fi3: 'Supercharge agent performance with Agent Skills and MCPs',
                fi4: 'Built with enterprise-grade security at its core',
            },
        },
    },
    ip: {
        mostPopular: 'Most Popular',
        plans: {
            basic: {
                name: 'Basic',
                price: 'Free',
                description: 'Ideal for individuals exploring IP search and analysis',
                cta: 'Current Plan',
                fi1: 'Limited patent search',
                fi2: 'Basic patent analysis',
                fi3: 'Try AI patent Q&A',
            },
            pro: {
                name: 'Pro',
                draftingTitle: 'Patent Drafting',
                draftingPrice: '$329',
                draftingDescription: 'For patent attorneys — AI-assisted patent drafting and disclosure generation',
                draftingCta: 'Subscribe to Pro',
                searchTitle: 'Patent Search',
                searchPrice: '$329',
                searchDescription: 'For R&D professionals — deep patent search and technical analysis',
                searchCta: 'Subscribe to Pro',
                pricePeriod: '/monthly',
                featuresHeader: 'Access Patent Searching Agents with 10 Flexible Search Credits:',
                search_fi1: 'Novelty Search (1 credit per task)',
                search_fi2: 'FTO Search (2 credits per task)',
                search_fi3: 'Design FTO Search (1 credit per task)',
                draftingFeaturesHeader: 'Multiple drafting features to assist with global patent applications:',
                drafting_fi1: 'Additional Hiro messages',
                drafting_fi2: 'Full document exports',
                drafting_fi3: 'Invention Disclosure (10 Doc)',
                drafting_fi4: 'Patent Application (5 Doc)',
                drafting_fi5: 'Office Action Response (5 Doc)',
                drafting_fi6: 'Template/Instruction/Style',
                drafting_fi7: 'Word Plugin (coming soon)',
            },
            enterprise: {
                name: 'Enterprise',
                price: 'Contact us',
                description: 'For IP teams needing full-cycle IP management and enterprise-grade control',
                cta: 'Book a Demo',
                fh1: 'Everything in Pro, plus:',
                fi1: 'High-frequency usage for teams',
                fi2: 'Team collaboration & permission management',
                fi3: 'Patent portfolio analysis',
                fi4: 'Competitor patent monitoring',
                fi5: 'Patent value assessment',
                fh2: 'Security & Control',
                fi6: 'Strict file upload control',
                fi7: 'Private incognito mode',
                fi8: 'Unified team permission management',
                fi9: 'Dedicated customer support',
            },
            api: {
                name: 'API',
                price: 'Custom',
                description: 'Embed patent agents into your existing infrastructure',
                cta: 'Learn More',
                fi1: 'Plug-and-play deployment with flexible, usage-based pricing',
                fi2: 'Embed directly into your existing workflows through APIs, widgets, and connectors',
                fi3: 'Supercharge agent performance with Agent Skills and MCPs',
                fi4: 'Built with enterprise-grade security at its core',
            },
        },
    },
    ls: {
        mostPopular: 'Most Popular',
        savings: 'Save $480',
        yearlyPrice: '$4320',
        plans: {
            basic: {
                name: 'Basic',
                price: 'Free',
                description: 'Ideal for individuals validating a hypothesis or testing the platform',
                cta: 'Current Plan',
                fi1: 'Domain-specific Hiro research Q&A',
                fi2: 'Document analysis for patent, literature, conference posters comparison (2 files/upload)',
                fi3: 'Try lead compound analysis with SAR data extraction (5 times only)',
                fi4: '2 AI-enabled Pulse briefs to spot market signals early',
            },
            pro: {
                name: 'Pro',
                price: '$400',
                period: '/month',
                description: 'Full research capabilities for working scientists',
                cta: 'Subscribe to Pro',
                badge: { monthly: 'Monthly', yearly: 'Yearly' },
                fh1: 'Everything in Basic, plus:',
                fi1: 'Up to 7.5X higher daily usage limit',
                fi3: 'Expanded functionalities for Document Analysis (5 files/upload)',
                fi4: 'Export enabled for Lead Compound Analysis (5/month)',
                fi5: '5 Weekly AI-enabled Pulse Briefings',
            },
            enterprise: {
                name: 'Enterprise',
                price: 'Contact us',
                description: 'Scale discovery across your whole team',
                cta: 'Book a Demo',
                fh1: 'Deep Science',
                fi1: 'SAR extraction coming soon',
                fi2: 'Connection from Structures to Markush agent',
                fh2: 'Expanded Capabilities',
                fi3: 'Increased usage with higher-tier model performance',
                fi4: 'Built-in system of record',
                fi5: 'Full file exports (FASTA, SDF, SMILES)',
                fi6: 'Additional expert AI agents (Antibody Target Predictor, Markush Claim Drafting, Pharma CI Explorer)',
                fh3: 'Security & Control',
                fi7: 'Shared projects',
                fi8: 'Team collaboration',
                fi9: 'Enterprise security with SSO and admin controls',
                fi10: 'Dedicated Customer Support',
            },
            api: {
                name: 'API',
                price: 'Custom',
                description: 'Embed agents into your research infrastructure',
                cta: 'Learn More',
                fi1: 'Plug-and-play deployment with flexible, usage-based pricing',
                fi2: 'Embed directly into your existing workflows through APIs, widgets, and connectors',
                fi3: 'Supercharge agent performance with Agent Skills and MCPs',
                fi4: 'Built with enterprise-grade security at its core',
            },
        },
    },
    error: {
        createPaymentSessionFailed: 'Failed to create payment, please try again later',
    },
};

export const jp = {
    title: {
        manageSubscription: 'サブスクリプション管理',
        pickYourPlan: 'プランを選択',
        basicUser: 'プランと料金',
        overlimitFreemium: '無料プランの上限に達しました',
        upgrade: 'さらに多くの機能を利用できます',
        overlimit: '現在のプラン上限に達しました',
        proUser: 'サブスクリプション管理',
    },
    subtitle: {
        pickYourPlan: 'あなたに合ったプランをお選びください',
        basicUser: '必要に応じて選ぶ，最適なプランを見つけよう',
        overlimitFreemium: '無料枠を使い切りました。続けるにはアップグレードが必要です。',
        upgrade: 'アップグレードすると、より高い上限と高度な機能が利用できます。',
        overlimit: '利用枠の拡大をご希望ですか？お客様に最適なプランをご提案します。営業担当までお問い合わせください。',
        proUser: 'サブスクリプション管理',
    },
    recommend: 'おすすめ',
    currentPlan: '現在のプラン',
    active: '有効',
    canceled: 'キャンセル済み',
    changePlan: 'プラン変更',
    cancelPlan: 'プランキャンセル',
    resumePlan: 'プラン再開',
    month: '月',
    year: '年',
    flashSale: '閃促 50% OFF',
    billingCycle: {
        monthly: '月払い',
        yearly: '年払い',
        saveAmount: '${amount} お得',
        recommended: '最も選ばれている',
    },
    plans: {
        basic: {
            sectionTitle: 'ベーシックプラン',
            featureTitle: 'ベーシックプラン機能:',
            name: 'ベーシック',
            price: '無料',
            description: '技術トレンドの探索や基本的な質問への回答を行いたい個人に最適です',
            features: {
                track: '限定的な技術トピックの追跡',
                'ai-qa': '基本的なAI技術Q&A',
                triz: 'TRIZによるイノベーション創出',
                report: '技術調査レポートの試用',
            },
        },
        pro: {
            sectionTitle: 'プロプラン',
            featureTitle: 'プロプラン機能',
            name: 'プロ',
            description: '深い分析と専門的なレポートを必要とするシニアR&Dプロフェッショナル向け',
            buttonText: 'Proに登録する',
            featuresHeader: 'プラン機能:',
            features: {
                proPlanFeatures: 'Basicプランの全機能に加え：',
                track: 'より多くの技術トピックの追跡',
                'ai-qa': 'AI Q&Aの利用枠拡大',
                triz: '複雑な問題へのTRIZの深い適用',
                'triz-library': 'TRIZ事例ライブラリの全機能解放',
                report: '専門的な深掘り調査レポートの作成',
                download: 'レポート文書のダウンロード/エクスポート',
            },
        },
        enterprise: {
            name: 'エンタープライズ',
            price: 'お問い合わせ',
            description: 'ライフサイクル全体の効率化ツールと企業レベルの管理を必要とするR&Dチーム向け',
            buttonText: 'デモを予約する',
            featuresHeader: 'プロ版に加えて:',
            features: {
                'in-pro-plus': 'Proプランの全機能に加え：',
                'high-frequency': 'チーム向けの頻繁な利用',
                'triz-expert': 'TRIZエキスパートモード（カスタムパラメータ）',
                'full-cycle': 'R&Dライフサイクル全体の効率化：',
                'company-search': '企業検索',
                'competitive-landscape': '競合状況分析',
                'assess-technical': '技術的実現可能性の評価',
                'prevent-design-failure': '設計失敗リスクの防止 (DFMEA)',
                'novelty-search': '新規性調査と検証',
                'patent-disclosure': '特許開示ドラフト作成アシスタント',
                'security-control': 'セキュリティと管理：',
                'internal-distribution': '内部インテリジェンスの共有',
                'strict-file-upload': '厳格なファイルアップロード管理',
                'private-incognito': 'プライベート・シークレットモード',
                'unified-permission': '統合されたチーム権限管理',
                'dedicated-support': '専任カスタマーサポート',
            },
        },
        api: {
            name: 'API',
            price: 'カスタム',
            description: '当社のAIモデルと独自の根拠資料をワークフローにシームレスに統合します',
            buttonText: '詳しく見る',
            featuresHeader: 'プロ版に加えて:',
            features: {
                'unified-ai-data-loop': '実用的なインサイトを得るための統合されたAIデータループ',
                'modular-components': 'モジュール化されたウィジェットとSDKによる即時統合',
                'transparent-usage': '透明性のある利用モデルによる予測可能なスケーリング',
                'enterprise-infrastructure': '99.9%のSLAを保証する企業向けインフラストラクチャ',
                'common-connectivity': '主要な技術スタックにわたるユニバーサルな接続性',
                'proactive-support': 'プロアクティブなサポートとフルスタックのヘルスモニタリング',
            },
        },
    },
    viewMoreDetails: '詳細を見る',
    tabs: {
        engineering: 'エンジニアリング',
        ip: '知的財産',
        materials: '材料科学',
        lifeSciences: 'ライフサイエンス',
        comingSoon: '近日公開',
    },
    mse: {
        mostPopular: '最も人気',
        savings: '10%お得',
        yearlyPrice: '$2,160',
        plans: {
            basic: {
                name: 'ベーシック',
                price: '無料',
                description: '材料仮説を検証したり、プラットフォームを試したりする科学者に最適',
                cta: '現在のプラン',
                fi1: '限定的な技術トピックの追跡',
                fi2: '材料技術Q&A',
                fi3: '配合エージェント',
            },
            pro: {
                name: 'プロ',
                price: '$200',
                period: '/月',
                description: '現役の材料科学者向けの完全な研究機能',
                cta: 'Proに登録する',
                badge: { monthly: '月払い', yearly: '年払い' },
                fh1: 'Basicプランの全機能に加え：',
                fi1: 'より多くの技術トピックの追跡',
                fi2: '利用上限の拡大',
                fi3: '参照ソースからの詳細な配合インサイトの解放',
                fi4: '配合結果と全文特許のエクスポート',
            },
            enterprise: {
                name: 'エンタープライズ',
                price: '営業に問い合わせ',
                description: 'チーム全体で材料発見をスケールアップ',
                cta: 'デモを予約する',
                fh1: 'Proプランの全機能に加え：',
                fi1: 'チーム向けの高頻度利用',
                fi2: '共有スペースでのコラボレーション',
                fh2: 'エンドツーエンドの材料インテリジェンス',
                fi3: 'AI技術ソリューション発見',
                fi4: '初期設計リスク分析 (DFMEA)',
                fi5: '包括的な新規性評価',
                fi6: 'AIによるIP文書作成支援',
                fh3: 'セキュリティと管理',
                fi7: '厳格なファイルアップロード管理',
                fi8: 'プライベート・シークレットモード',
                fi9: '統合されたチーム権限管理',
                fi10: '専任カスタマーサポート',
            },
            api: {
                name: 'API',
                price: 'カスタム',
                description: '材料エージェントを既存のインフラに組み込む',
                cta: '詳しく見る',
                fi1: '柔軟な従量課金制によるプラグアンドプレイ展開',
                fi2: 'API、ウィジェット、コネクタを通じて既存ワークフローに直接組み込み',
                fi3: 'Agent SkillsとMCPでエージェント性能を強化',
                fi4: 'エンタープライズグレードのセキュリティを核心に構築',
            },
        },
    },
    ip: {
        mostPopular: '最も人気',
        plans: {
            basic: {
                name: 'ベーシック',
                price: '無料',
                description: '特許検索と分析を探索したい個人に最適',
                cta: '現在のプラン',
                fi1: '限定的な特許検索',
                fi2: '基本的な特許分析',
                fi3: 'AI特許Q&Aの試用',
            },
            pro: {
                name: 'プロ',
                draftingTitle: '特許作成',
                draftingPrice: '$329',
                draftingDescription: '特許代理人向け — AI支援による特許作成と開示書生成',
                draftingCta: 'Proに登録する',
                searchTitle: '特許検索',
                searchPrice: '$329',
                searchDescription: 'R&D専門家向け — 深度特許検索と技術分析',
                searchCta: 'Proに登録する',
                pricePeriod: '/月',
                featuresHeader: '10回の柔軟な検索クレジット付き特許検索エージェント：',
                search_fi1: '新規性調査（1タスクにつき1クレジット）',
                search_fi2: 'FTO調査（1タスクにつき2クレジット）',
                search_fi3: '意匠FTO調査（1タスクにつき1クレジット）',
                draftingFeaturesHeader: 'グローバル特許出願を支援する複数の作成機能：',
                drafting_fi1: 'Hiroメッセージの追加',
                drafting_fi2: '完全なドキュメントエクスポート',
                drafting_fi3: '発明開示書（10件）',
                drafting_fi4: '特許出願書類（5件）',
                drafting_fi5: '拒絶理由通知への応答（5件）',
                drafting_fi6: 'テンプレート/指示/スタイル',
                drafting_fi7: 'Wordプラグイン（近日公開）',
            },
            enterprise: {
                name: 'エンタープライズ',
                price: 'お問い合わせ',
                description: 'フルサイクルIP管理と企業レベルの管理を必要とするIPチーム向け',
                cta: 'デモを予約する',
                fh1: 'Proプランの全機能に加え：',
                fi1: 'チーム向けの高頻度利用',
                fi2: 'チームコラボレーションと権限管理',
                fi3: '特許ポートフォリオ分析',
                fi4: '競合他社の特許監視',
                fi5: '特許価値評価',
                fh2: 'セキュリティと管理',
                fi6: '厳格なファイルアップロード管理',
                fi7: 'プライベート・シークレットモード',
                fi8: '統合されたチーム権限管理',
                fi9: '専任カスタマーサポート',
            },
            api: {
                name: 'API',
                price: 'カスタム',
                description: '特許エージェントを既存のインフラに組み込む',
                cta: '詳しく見る',
                fi1: '柔軟な従量課金制によるプラグアンドプレイ展開',
                fi2: 'API、ウィジェット、コネクタを通じて既存ワークフローに直接組み込み',
                fi3: 'Agent SkillsとMCPでエージェント性能を強化',
                fi4: 'エンタープライズグレードのセキュリティを核心に構築',
            },
        },
    },
    ls: {
        mostPopular: '最も人気',
        savings: '$480 お得',
        yearlyPrice: '$4320',
        plans: {
            basic: {
                name: 'ベーシック',
                price: '無料',
                description: '仮説検証やプラットフォーム体験に最適な個人向けプラン',
                cta: '現在のプラン',
                fi1: 'ライフサイエンス領域特化の Hiro リサーチQ&A',
                fi2: 'ドキュメント精読で特許・文献・学会ポスターを比較分析（1回最大2ファイル）',
                fi3: 'Lead化合物分析 & SARデータ抽出を体験（5回限定）',
                fi4: '2件のAI駆動インテリジェンスブリーフ、市場シグナルをいち早くキャッチ',
            },
            pro: {
                name: 'プロ',
                price: '$400',
                period: '/月',
                description: '研究者のための本格的なリサーチ機能',
                cta: 'Proに登録する',
                badge: { monthly: '月払い', yearly: '年払い' },
                fh1: 'ベーシックの全機能に加えて：',
                fi1: '1日あたりの利用枠が最大7.5倍に拡大',
                fi3: 'ドキュメント精読機能を拡張（1回最大5ファイル）',
                fi4: 'Lead化合物分析のエクスポート機能を開放（月5回）',
                fi5: '5件のAI駆動インテリジェンスブリーフ（毎週更新）',
            },
            enterprise: {
                name: 'エンタープライズ',
                price: 'お問い合わせ',
                description: 'チーム全体の創薬ディスカバリーを加速',
                cta: 'デモを予約',
                fh1: 'ディープサイエンス',
                fi1: 'SAR抽出近日公開',
                fi2: '構造からマーカッシュエージェントへの連携パス',
                fh2: '能力拡張',
                fi3: 'より多い利用枠と高性能モデル',
                fi4: '内蔵の研究記録システム',
                fi5: '全フォーマットファイルエクスポート（FASTA、SDF、SMILES）',
                fi6: '追加エキスパートエージェント（知財レポート、抗体抗原スクリーニング、マーカッシュ起草）',
                fh3: 'セキュリティと管理',
                fi7: '共有プロジェクト',
                fi8: 'チームコラボレーション',
                fi9: 'SSOおよび管理者コントロールを備えたエンタープライズセキュリティ',
                fi10: '専任カスタマーサポート',
            },
            api: {
                name: 'API',
                price: 'カスタム見積もり',
                description: 'エージェントを研究ワークフローに統合',
                cta: '詳細を見る',
                fi1: 'プラグアンドプレイで導入、従量課金で柔軟に運用',
                fi2: 'API・ウィジェット・コネクタで既存ワークフローに直接組み込み',
                fi3: 'Agent SkillsとMCPでエージェント性能を大幅強化',
                fi4: 'エンタープライズグレードのセキュリティを基盤から構築',
            },
        },
    },
    error: {
        createPaymentSessionFailed: '支払いの作成に失敗しました,後でもう一度お試しください',
    },
};

export const tw = {
    title: {
        manageSubscription: '管理訂閱',
        pickYourPlan: '選擇方案',
        basicUser: '定價方案',
        overlimitFreemium: '已達到免費版使用上限',
        upgrade: '解鎖更多能力',
        overlimit: '已達到目前方案上限',
        proUser: '管理訂閱',
    },
    subtitle: {
        pickYourPlan: '選擇適合您的方案',
        basicUser: '解鎖專業功能按需選擇，找到最適合你的方案',
        overlimitFreemium: '目前免費額度已用完，升級後可繼續使用。',
        upgrade: '升級方案，獲得更高額度和更多進階功能。',
        overlimit: '需要更多用量？聯繫銷售以獲取最適合您的方案。',
        proUser: '管理您的訂閱',
    },
    recommend: '推薦',
    currentPlan: '目前方案',
    active: '已啟用',
    canceled: '已取消',
    changePlan: '切換方案',
    cancelPlan: '取消方案',
    resumePlan: '恢復方案',
    month: '月',
    year: '年',
    flashSale: '閃促 50% OFF',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '省 ${amount}',
        recommended: '人氣首選',
    },
    plans: {
        basic: {
            sectionTitle: '您的基礎方案',
            featureTitle: '基礎方案功能:',
            name: '基礎版',
            price: '免費',
            description: '適合個人初次體驗，快速了解技術趨勢與解答基礎問題',
            features: {
                track: '關注少量技術話題動態',
                'ai-qa': '基礎 AI 技術問答',
                triz: '體驗 TRIZ 創新方案生成',
                report: '體驗技術調研報告生成',
            },
        },
        pro: {
            sectionTitle: '您的方案',
            featureTitle: '專業方案功能',
            name: '個人專業版',
            description: '適合資深研發人員，解鎖深度分析能力與專業報告導出',
            buttonText: '立即升級',
            featuresHeader: '方案功能:',
            features: {
                proPlanFeatures: '包含免費版所有功能，額外：',
                track: '監控更多技術話題動態',
                'ai-qa': '更充裕的 AI 問答額度',
                triz: '深度應用 TRIZ 攻克技術難題',
                'triz-library': '解鎖完整 TRIZ 創新案例庫',
                report: '生成深度專業的技術調研報告',
                download: '支援下載 / 導出報告文檔',
            },
        },
        enterprise: {
            name: '企業版',
            price: '聯繫我們',
            description: '適合研發團隊，提供全流程提效工具與企業級安全管控',
            buttonText: '諮詢專家',
            featuresHeader: '包含專業版,以及:',
            features: {
                'in-pro-plus': '包含專業版所有功能，額外：',
                'high-frequency': '滿足團隊規模化的高頻使用需求',
                'triz-expert': 'TRIZ 專家模式（支援自定義參數）',
                'full-cycle': '全流程研發提效',
                'company-search': '公司搜索',
                'competitive-landscape': '競爭格局',
                'assess-technical': '評估技術方案可行性',
                'prevent-design-failure': '預防設計失效風險 (DFMEA)',
                'novelty-search': '檢查技術創意新穎性（查新）',
                'patent-disclosure': '輔助撰寫專利交底書',
                'security-control': '安全與管理',
                'internal-distribution': '團隊內部分發情報簡報',
                'strict-file-upload': '嚴格的文件上傳權限控制',
                'private-incognito': '保護隱私的無痕模式',
                'unified-permission': '統一管理團隊成員權限',
                'dedicated-support': '專屬客戶服務支持',
            },
        },
        api: {
            name: 'API',
            price: '客製化',
            description: '將我們的 AI 模型和專有資料無縫集成到您的工作流程中',
            buttonText: '瞭解更多',
            featuresHeader: '包含專業版,以及:',
            features: {
                'unified-ai-data-loop': '統一的 AI 數據閉環，提供可落地的洞察',
                'modular-components': '透過模組化組件和 SDK 實現即時集成',
                'transparent-usage': '透明的使用模式，確保擴展的可預測性',
                'enterprise-infrastructure': '擁有 99.9% SLA 的企業級基礎設施',
                'common-connectivity': '支援主流技術棧的通用連接性',
                'proactive-support': '主動式支持與全線健康監測',
            },
        },
    },
    viewMoreDetails: '查看更多詳情',
    tabs: {
        engineering: '研發',
        ip: '知識產權',
        materials: '材料科學',
        lifeSciences: '生命科學',
        comingSoon: '即將上線',
    },
    mse: {
        mostPopular: '最受歡迎',
        savings: '省10%',
        yearlyPrice: '$2,160',
        plans: {
            basic: {
                name: '基礎版',
                price: '免費',
                description: '適合驗證材料假設或試用平台的科學家',
                cta: '目前方案',
                fi1: '追蹤有限技術話題',
                fi2: '材料技術問答',
                fi3: '配方智能體',
            },
            pro: {
                name: '專業版',
                price: '$200',
                period: '/月',
                description: '為在職材料科學家提供完整研究能力',
                cta: '訂閱專業版',
                badge: { monthly: '月付', yearly: '年付' },
                fh1: '包含免費版所有功能，額外：',
                fi1: '追蹤更多技術話題',
                fi2: '更高使用限額',
                fi3: '解鎖來自參考來源的詳細配方洞察',
                fi4: '匯出配方結果和全文專利',
            },
            enterprise: {
                name: '企業版',
                price: '聯繫銷售',
                description: '在整個團隊中擴展材料發現能力',
                cta: '預約演示',
                fh1: '包含專業版所有功能，額外：',
                fi1: '滿足團隊高頻使用需求',
                fi2: '在共享空間協作',
                fh2: '端到端材料智能',
                fi3: 'AI 技術解決方案發現',
                fi4: '早期設計風險分析 (DFMEA)',
                fi5: '全面新穎性評估',
                fi6: 'AI 輔助知識產權文件',
                fh3: '安全與管控',
                fi7: '嚴格的文件上傳控制',
                fi8: '隱私無痕模式',
                fi9: '統一團隊權限管理',
                fi10: '專屬客戶支持',
            },
            api: {
                name: 'API',
                price: '客製化',
                description: '將材料智能體嵌入您現有的基礎設施',
                cta: '瞭解更多',
                fi1: '即插即用部署，靈活按用量計費',
                fi2: '透過 API、組件和連接器直接嵌入現有工作流',
                fi3: '透過 Agent Skills 和 MCP 增強智能體性能',
                fi4: '以企業級安全為核心構建',
            },
        },
    },
    ip: {
        mostPopular: '人氣首選',
        plans: {
            basic: {
                name: '基礎版',
                price: '免費',
                description: '適合個人初次體驗知識產權檢索與分析',
                cta: '目前方案',
                fi1: '有限專利檢索',
                fi2: '基礎專利分析',
                fi3: '體驗 AI 專利問答',
            },
            pro: {
                name: '專業版',
                draftingTitle: '專利撰寫',
                draftingPrice: '$329',
                draftingDescription: '適合專利代理人，AI 輔助專利撰寫與交底書生成',
                draftingCta: '訂閱專業版',
                searchTitle: '專利檢索',
                searchPrice: '$329',
                searchDescription: '適合研發人員，深度專利檢索與技術分析',
                searchCta: '訂閱專業版',
                pricePeriod: '/月',
                featuresHeader: '專利檢索智能體，含 10 個靈活搜索積分：',
                search_fi1: '新穎性檢索（每個任務 1 積分）',
                search_fi2: 'FTO 檢索（每個任務 2 積分）',
                search_fi3: '外觀設計 FTO 檢索（每個任務 1 積分）',
                draftingFeaturesHeader: '多項撰寫功能，助力全球專利申請：',
                drafting_fi1: '更多 Hiro 訊息額度',
                drafting_fi2: '完整文件匯出',
                drafting_fi3: '專利交底書（10 份）',
                drafting_fi4: '專利申請文件（5 份）',
                drafting_fi5: '審查意見答覆（5 份）',
                drafting_fi6: '範本 / 指令 / 風格',
                drafting_fi7: 'Word 外掛（即將推出）',
            },
            enterprise: {
                name: '企業版',
                price: '聯繫我們',
                description: '適合知識產權團隊，提供全流程 IP 管理與企業級安全管控',
                cta: '預約演示',
                fh1: '包含專業版所有功能，額外：',
                fi1: '滿足團隊高頻使用需求',
                fi2: '團隊協作與權限管理',
                fi3: '專利組合分析',
                fi4: '競爭對手專利監控',
                fi5: '專利價值評估',
                fh2: '安全與管控',
                fi6: '嚴格的文件上傳權限控制',
                fi7: '保護隱私的無痕模式',
                fi8: '統一管理團隊成員權限',
                fi9: '專屬客戶服務支持',
            },
            api: {
                name: 'API',
                price: '客製化',
                description: '將專利智能體嵌入您現有的基礎設施',
                cta: '瞭解更多',
                fi1: '即插即用部署，靈活按用量計費',
                fi2: '透過 API、組件和連接器直接嵌入現有工作流',
                fi3: '透過 Agent Skills 和 MCP 增強智能體性能',
                fi4: '以企業級安全為核心構建',
            },
        },
    },
    ls: {
        mostPopular: '人氣首選',
        savings: '節省$480',
        yearlyPrice: '$4320',
        plans: {
            basic: {
                name: '基礎版',
                price: '免費',
                description: '適合驗證研究假設或體驗平台的個人用戶',
                cta: '目前方案',
                fi1: '生命科學領域專屬 Hiro 科研問答',
                fi2: '文檔精讀專利、文獻、會議海報對比分析（每次至多上傳2個檔案）',
                fi3: '體驗 Lead化合物分析及 SAR 數據提取（僅限5次）',
                fi4: '2份AI驅動情報簡報，提前捕捉市場訊號',
            },
            pro: {
                name: '專業版',
                price: '$400',
                period: '/月',
                description: '為科研工作者提供完整的研究能力',
                cta: '訂閱專業版',
                badge: { monthly: '月付', yearly: '年付' },
                fh1: '包含基礎版全部功能，以及：',
                fi1: '每日使用額度最高提升7.5倍',
                fi3: '文檔精讀功能擴展（每次至多上傳5個檔案）',
                fi4: 'Lead化合物分析開放導出（每月5次）',
                fi5: '5份AI驅動情報簡報（每週更新）',
            },
            enterprise: {
                name: '企業版',
                price: '聯繫我們',
                description: '賦能全團隊的科研發現',
                cta: '預約示範',
                fh1: '深度科研',
                fi1: 'SAR提取即將上線',
                fi2: '結構到馬庫什智能體的關聯通路',
                fh2: '能力擴展',
                fi3: '更高用量配額與更高效能模型',
                fi4: '內建科研記錄系統',
                fi5: '全格式檔案導出（FASTA、SDF、SMILES）',
                fi6: '額外專家智能體（知產報告、抗體抗原篩選、馬庫什撰寫）',
                fh3: '安全與管控',
                fi7: '共享項目',
                fi8: '團隊協作',
                fi9: '企業級安全與SSO及管理員控制',
                fi10: '專屬客戶支持',
            },
            api: {
                name: 'API',
                price: '客製化報價',
                description: '讓智能體融入您的研究工作流',
                cta: '了解更多',
                fi1: '即插即用部署，按用量靈活計費',
                fi2: '透過API、元件和連接器直接嵌入現有工作流',
                fi3: '藉助Agent Skills與MCP大幅提升智能體能力',
                fi4: '從底層構建企業級安全架構',
            },
        },
    },
    error: {
        createPaymentSessionFailed: '建立付款失敗，請稍後再試',
    },
};
